
export default {
    getTranslations: (state) => state.translations,
}